import type { SupportedLocale } from '@erp/shared';

export const headerTranslations = {
  de: {
    more: 'Weitere Aktionen und Benutzerkonto',
    salesTasks: 'Vertriebsaufgaben',
    actions: 'Aktionen',
    preferences: 'Persönliche Einstellungen',
    introductionActive: 'Einführungsmodus aktiv',
    protected: 'Bestand geschützt · Einführung inaktiv',
    statusUnknown: 'Betriebsmodus unbekannt',
    statusLoading: 'Betriebsmodus wird geprüft …',
  },
  en: {
    more: 'More actions and account',
    salesTasks: 'Sales tasks',
    actions: 'Actions',
    preferences: 'Personal preferences',
    introductionActive: 'Introduction mode active',
    protected: 'Data protected · introduction inactive',
    statusUnknown: 'Operating mode unknown',
    statusLoading: 'Checking operating mode …',
  },
  fr: {
    more: 'Autres actions et compte',
    salesTasks: 'Tâches commerciales',
    actions: 'Actions',
    preferences: 'Préférences personnelles',
    introductionActive: 'Mise en service active',
    protected: 'Données protégées · introduction inactive',
    statusUnknown: 'Mode de fonctionnement inconnu',
    statusLoading: 'Vérification du mode …',
  },
  es: {
    more: 'Más acciones y cuenta',
    salesTasks: 'Tareas comerciales',
    actions: 'Acciones',
    preferences: 'Preferencias personales',
    introductionActive: 'Puesta en marcha activa',
    protected: 'Datos protegidos · introducción inactiva',
    statusUnknown: 'Modo operativo desconocido',
    statusLoading: 'Comprobando el modo …',
  },
  tr: {
    more: 'Diğer işlemler ve hesap',
    salesTasks: 'Satış görevleri',
    actions: 'İşlemler',
    preferences: 'Kişisel tercihler',
    introductionActive: 'Devreye alma modu etkin',
    protected: 'Veriler korunuyor · devreye alma etkin değil',
    statusUnknown: 'İşletim modu bilinmiyor',
    statusLoading: 'İşletim modu kontrol ediliyor …',
  },
} satisfies Record<SupportedLocale, Record<string, string>>;
